export default {"src":"/_next/static/media/name_mismatch.3dcd1317.svg","height":243,"width":301,"blurWidth":0,"blurHeight":0};